function LanguageController(){
	this.className	= "HeaderController";
	this.glob		    = '**';
	this.time		 = 750;
};
LanguageController.inheritsFrom( StandardController );
LanguageController.prototype.swap = function(){
	this.$html 		= $('html');
	this.$body 		= $('body');

	//if(!this.isSetup) {
		//this.isSetup = true;
		this.setupDropdown();
	//}
};
LanguageController.prototype.setupDropdown = function($holder){
	if(!$holder) $holder = $(".js-page-header:first");

	const $languageSelect = $holder.find(".js-language-selector:visible");

	const animationController = new AcceleratePositionToggle( {
		x:			0,
		a: 			40,
		onChange: 	function(x) {
			const mc = Aviator.get("menuController");

			const $l = $languageSelect; //$languageSelect.first();
			const $dd = $l.find(".language-selector__dropdown");

			const h1 = $dd.prop('scrollHeight');

			const y = x * h1;
			$dd.height(y);
		},
		onComplete:	function(x){
			if(x < 0.00001){
				$languageSelect.removeClass("open");
			}
		},
		onStart:	function(x,details){
			if(details.end > 0){
				const mc = Aviator.get("menuController");
				const $l = $languageSelect; //$languageSelect.first();
				const $dd = $l.find(".language-selector__dropdown");



				$dd.height("");

				$languageSelect.addClass("open");
			}
		}
	});

	const off = function(e){
		const mc = Aviator.get("menuController");

		const isSelector = $(e.currentTarget).parents('.js-language-selector');

		if(e && e.type === "mouseover") return;

		if(e){
			e.preventDefault();
			e.stopPropagation();
		}

		$languageSelect.removeClass("hover");
		animationController.change(0);

		$("body").off("click", off);
	};

	const on = function(e){
		const mc = Aviator.get("menuController");

		console.log("??");
		// if(e.type === "mouseover") return;

		e.preventDefault();
		e.stopPropagation();

		if(!$languageSelect.hasClass("hover")){
			$languageSelect.addClass("hover");

			console.log(e);

			// const lang = e.dataset('lang');
			// console.log(lang);

			animationController.change(1);
			// $("body").on("click", off);
		}else{
			off(e);
		}
	}

	// $languageSelect.off("click").on("click",off);

	// $languageSelect.find(".language-selector__selected").off("click touchstart").on("click",function(e){
	// 	e.preventDefault();
	// });
	//

	const $selectButton = $languageSelect.find('div:first')

	$selectButton.off("touchstart").on("touchstart",on);

	// $languageSelect.each(function(){
	// 	const $li = $(this).find("li").first();
	// 	$li.find("a").off("click touchstart").on("click",function(e){e.preventDefault();});
	// 	$li.off("click").on("click",on);
	// });

	$languageSelect.off("mouseover").on("mouseover",on).off("mouseout").on("mouseout",off); //mouseover

	this.resizeDelegate = jstage.addListener("resize", (e) => this.onResize(e));
}
LanguageController.prototype.onResize = function( e ){
	//this.setupDropdown();
}
LanguageController.prototype.off = function( onComplete ){
	const state = nav.getState();
	if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
}
